var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacupLightGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59249 6.85718H18.1639V15.4286C18.1639 16.3379 17.8027 17.21 17.1597 17.853C16.5167 18.496 15.6447 18.8572 14.7354 18.8572H6.16392C5.25461 18.8572 4.38254 18.496 3.73956 17.853C3.09657 17.21 2.73535 16.3379 2.73535 15.4286V7.71432C2.73535 7.48699 2.82566 7.26897 2.9864 7.10823C3.14715 6.94748 3.36517 6.85718 3.59249 6.85718Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02148 23.1428H23.3072",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 6.85718H19.8783C20.7877 6.85718 21.6597 7.2184 22.3027 7.86138C22.9457 8.50436 23.3069 9.37644 23.3069 10.2857C23.3069 11.1951 22.9457 12.0671 22.3027 12.7101C21.6597 13.3531 20.7877 13.7143 19.8783 13.7143H18.1641",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30762 0.857178V2.57146",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8789 0.857178V2.57146",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59277 0.857178V2.57146",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacupLightGreyIcon);
export default __webpack_public_path__ + "static/media/teacup-light-grey-icon.75f93f0dba61468c6b37c1132a86fa39.svg";
export { ForwardRef as ReactComponent };